'use client';

import classnames from 'classnames';
import {
  HeaderBlock as V3HeaderBlock,
  HeaderBlockProps,
} from '@stadionhq-v3/base-ui';
// eslint-disable-next-line no-restricted-imports
import { usePathname } from 'next/navigation';
import subNavStyles from '@components/v3/atoms/page-navigation-segment/pageNavigationSegment.module.scss';
import buttonStyles from '../../atoms/button/button.module.scss';

import styles from './headerBlock.module.scss';

export const HeaderBlock = ({ link, subNav, ...props }: HeaderBlockProps) => {
  const classes = classnames([
    styles.headerBlockTokens,
    styles.headerBlock,
    props.theme?.themeId ? styles[props.theme.themeId] : styles.colourTheme1,
    props.type && styles[props.type],
  ]);

  const pathname = usePathname();
  const currentUrl = pathname;

  return (
    <V3HeaderBlock
      classNames={[classes]}
      link={
        link && {
          ...link,
          classNames: [
            classnames(
              buttonStyles.textButton,
              buttonStyles.button,
              buttonStyles.buttonTokens,
              props.theme?.themeId && buttonStyles[props.theme.themeId]
            ),
          ],
        }
      }
      subNav={subNav?.map((subNavItem) => ({
        ...subNavItem,
        classNames: [
          classnames(
            subNavStyles.pageNavSegment,
            subNavStyles.pageNavSegmentTokens,
            subNavStyles.buttonTokens,
            props.theme?.themeId &&
              !props.onDark &&
              subNavStyles[props.theme?.themeId],
            {
              [`${subNavStyles.onDark}`]: props.onDark,
              [`${subNavStyles.selected}`]:
                subNavItem.selected ||
                currentUrl === subNavItem.url ||
                currentUrl.includes(subNavItem.url),
            }
          ),
        ],
      }))}
      {...props}
    />
  );
};
